/**
 * Header
 **/
app.add({

    init: function(app){
        app.header = this.header;
    },

    header: {
        change: function(url){
            if (!url) return;
            var img = $('#header img')
            img.velocity({opacity: 0}, 250, onHide);

            function onHide(){
                img.attr('src', url)
                   .attr('srcset', url.concat(' 2x'))
                   .velocity({opacity: 1}, 250);
            }
        }
    }

});













// WEBPACK FOOTER //
// ./resources/assets/js/modules/header.js